<template>
  <div>
    <div class="modal fade show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Ustaw saldo początkowe</h4>
            <button class="close" type="button" @click="cancelUpdate()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="setInitialLoyaltyBalance()">
              <div class="row">
                <div class="form-group col-md-4">
                  <input class="form-control" id="balance" v-model="balance" type="text"/>
                </div>
              </div>
              <button class="btn btn-primary mr-2" type="submit">Zapisz</button>
              <button class="btn btn-secondary" @click="cancelUpdate()" type="button">Anuluj</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
  import clientService from '@Service/clients';

  export default {
    props: ['client'],
    data() {
      return {
        balance: '',
      };
    },
    mounted() {
      this.balance = this.client.initialLoyaltyBalance;
    },
    methods: {
      cancelUpdate() {
        this.$emit('cancel-loyalty-balance-update');
      },
      setInitialLoyaltyBalance() {
        const balance = parseFloat(this.balance.replace(',', '.'));
        if (isNaN(balance)) {
          return;
        }
        clientService
          .updateInitialLoyaltyBalance(this.client.clientId, balance)
          .then(() => {
            this.cancelUpdate();
            this.$emit('client-updated');
          });
      },
    },
  };
</script>
